import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import ProgressPage from './ProgressPage';
import PortfolioPage from './PortfolioPage';
import PitchesPage from './PitchesPage';

export default function RecordPage() {
  return (
    <div className="min-h-screen bg-background">
      <Tabs defaultValue="progress">
        <div className="border-b border-border bg-card px-8 pt-5 pb-0">
          <TabsList className="bg-transparent p-0 h-auto gap-6 rounded-none">
            <TabsTrigger
              value="progress"
              className="uppercase tracking-wide text-xs font-medium pb-4 px-0 rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
            >
              Progress
            </TabsTrigger>
            <TabsTrigger
              value="portfolio"
              className="uppercase tracking-wide text-xs font-medium pb-4 px-0 rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
            >
              Portfolio
            </TabsTrigger>
            <TabsTrigger
              value="pitches"
              className="uppercase tracking-wide text-xs font-medium pb-4 px-0 rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
            >
              Pitches
            </TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value="progress" className="mt-0">
          <ProgressPage />
        </TabsContent>
        <TabsContent value="portfolio" className="mt-0">
          <PortfolioPage />
        </TabsContent>
        <TabsContent value="pitches" className="mt-0">
          <PitchesPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}
